import { Event_ } from '../Event_';
export class TouchEvent_ extends Event_ {
    get touches() {
        return this.reactEvent.touches;
    }
}
